// extracted by mini-css-extract-plugin
module.exports = {"slider":"horizontal-slider-module__slider___3lyBO"};